module.exports = __webpack_public_path__ + "static/media/revenue_ops_use_case_1.c846b2d7.svg";